// .pen: stUfe (ds/selfie/live-networth-bar)
import { ArrowDown, ArrowUp } from '@phosphor-icons/react';

import pt from '../../../locales/pt';
import { cn } from '../../../utils/cn';
import { formatEUR } from '../../../utils/money';

function format(template, params) {
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    params[key] === undefined ? `{${key}}` : String(params[key]),
  );
}

// .pen: stUfe (ds/selfie/live-networth-bar)
export function SelfieLiveNetWorthBar({
  total,
  delta = null,
  previousMonthLabel = null,
  hasPrevious = false,
  className,
}) {
  const copy = pt.snapshots.ritual.balances;
  const isUp = delta !== null && delta > 0;
  const isFlat = hasPrevious && delta !== null && delta === 0;

  return (
    <div
      data-ds-id="ds/selfie/live-networth-bar"
      className={cn(
        'flex items-center justify-between gap-space-3 rounded-ds-lg border border-sage-border bg-sage-tint px-space-4 py-space-3',
        className,
      )}
    >
      <div className="flex flex-col gap-space-1">
        <p className="type-section text-sage-on-tint">{copy.liveLabel}</p>
        <p className="font-display text-type-display-metric font-bold leading-[1.1] tracking-tight text-foreground tabular-nums">
          {formatEUR(total)}
        </p>
      </div>

      {hasPrevious && delta !== null ? (
        <div className="flex flex-col items-end gap-space-1">
          {isFlat ? (
            <p className="text-type-label font-semibold text-muted-foreground">{copy.liveFlat}</p>
          ) : (
            <span
              className={cn(
                'inline-flex items-center gap-space-1 rounded-ds-full bg-card px-space-2-5 py-space-1 text-type-label font-bold',
                isUp ? 'text-sage-on-tint' : 'text-warning-fg',
              )}
            >
              {isUp ? (
                <ArrowUp className="size-3 shrink-0" weight="bold" aria-hidden />
              ) : (
                <ArrowDown className="size-3 shrink-0" weight="bold" aria-hidden />
              )}
              {delta >= 0 ? '+' : ''}
              {formatEUR(delta)}
            </span>
          )}
          {previousMonthLabel ? (
            <p className="text-right text-type-label text-muted-foreground">
              {format(copy.liveVsMonth, { month: previousMonthLabel.toLowerCase() })}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default SelfieLiveNetWorthBar;
